import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  InputLabel,
} from "@mui/material";
import axios from "axios";
import {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { config, departmentMasterAPI } from "../config";
import { AlertMessage } from "./AlertMessage";
import { Backdrop, CircularProgress } from "@mui/material";
import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  DepartmentName: Yup.string()
    .required("Department Name is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters")
    .matches(
      /^[a-zA-Z0-9 _-]+$/,
      "Only letters, numbers, spaces, hyphen (-) and underscore (_) are allowed"
    ),
});

export const AddDepartments = forwardRef(({ ...props }, ref) => {
  const [Status, setStatus] = useState(2),
    [DepartmentName, setDepartmentName] = useState(""),
    [DepartmentID, setDepartmentID] = useState(0);
  const [loading, setLoading] = useState(false);
  const alertRef = useRef();

  useImperativeHandle(ref, () => ({
    setData(data) {
      const tempData = JSON.parse(data);
      setDepartmentID(tempData.departmentID);
      setDepartmentName(tempData.txtDepartmentName);
      setStatus(tempData.status);
    },
  }));

  let tempRefs = useRef(false);

  useEffect(() => {}, []);

  const handleSubmit = async () => {
    try {
      await validationSchema.validate(
        { DepartmentName },
        { abortEarly: false }
      );

      setLoading(true);

      const data = JSON.stringify({
        txtDepartmentName: DepartmentName,
        intStatus: Status,
        intDepartmentID: DepartmentID,
        intType: 1,
      });

      // if ("" == DepartmentName) {
      //   childRef.current.triggerAlert(
      //     JSON.stringify({
      //       message: "Department Name Can't be empty",
      //       messageType: "error",
      //     })
      //   );
      //   return false;
      // }

      config.method = "POST";
      config.data = data;
      config.url = departmentMasterAPI;
      axios(config)
        .then(function (response) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: "success",
            })
          );
          if (response.data.code == 0) {
            setTimeout(() => {
              window.location.reload(false);
            }, 3000);
          }

          setDepartmentName("");
          setDepartmentID(0);
          setStatus(2);
          props.fetchData(1);
        })
        .catch(function (error) {
          console.log(error);
          childRef.current.triggerAlert(
            JSON.stringify({
              message: error.data.message,
              messageType: "error",
            })
          );
        });
    } catch (error) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: error.errors[0],
          messageType: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const childRef = useRef();
  return (
    <Grid container spacing={2} className={`bg-white`}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <AlertMessage ref={childRef} />
      <Grid item xs={12} md={5} lg={5}>
        <FormControl className={`form-control`} fullWidth>
          <TextField
            id="DepartmentName"
            name="DepartmentName"
            label="Department Name"
            value={DepartmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
          />
        </FormControl>
      </Grid>

      <Grid item xs={12} md={5} lg={5}>
        <FormControl className={`form-control`} fullWidth>
          <InputLabel id="demo-simple-select-label">Status</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Status"
            value={Status}
            onChange={(e) => {
              setStatus(e.target.value);
            }}
            name="ddlType"
          >
            <MenuItem value={`2`}>Active</MenuItem>
            <MenuItem value={`3`}>Inactive</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={2} lg={2} textAlign="right">
        <Button
          variant="primary"
          className={`btn-primary`}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
});
